import React from 'react';
import styled from 'styled-components';
import UniversalIconBtn from '../../../shared/component/headless/button/UniversalIconBtn';
import { useModalStore } from '../../../shared/store/portal/modalStore';
import { useImportStationTextStore } from '../../../shared/store/importStationTextStore';
import { useProjectDetailState } from '../../../shared/hooks/useApi/useProjectDetail';
import { useCanShowProjectDetail } from '../../../shared/hooks/useProjectVisibility';
import { useTextBlock } from '../../../shared/hooks/useApi/useTextBlock';
import SimpleText from '../SimpleText';
import belowIcon from '../../../asset/icon/below.png';
import { getModalMessage } from '../../../shared/constants/modalMessages';
import PageAboutTextImport from '../PageAboutTextImport';


const ImportStationTextMainMobile: React.FC = () => {
  const { clearModal } = useModalStore();
  const { selectedId, simpleList, clearSimpleList } = useImportStationTextStore();
  const { project } = useProjectDetailState();
  const canShowProject = useCanShowProjectDetail();
  const { selectTextForImport } = useTextBlock();

  const handleClose = () => {
    clearModal(400);
    clearSimpleList();
  };

  const onClickTextHandler = async (textId: string) => {
    await selectTextForImport(textId);
  };

  if (!canShowProject || !project) return null;

  return (
      <MainContainer $isActive={selectedId === ""}>
        {selectedId === "" && (
          <>
        <TitleWrapper>
          <TitleContainer>
            <Title>{getModalMessage('SELECT_TO_IMPORT_TEXT')}</Title>         
          </TitleContainer>
          <UniversalIconBtn
            size="fit"
            border={false}
            isTransparent={true}
            backgroundImg={belowIcon}
            onClick={handleClose}
            aria-label="Close"
          />
        </TitleWrapper>
        <ImportContentContainer>
        {simpleList.length === 0 ? (
          <NoContentContainer>
            Text does not exist.<br />
            Create Text First.
          </NoContentContainer>
        ) : (
          simpleList.map((sw) => (
            <SimpleContentComp key={sw.id}>
              <SimpleText data={sw} onClickHandler={onClickTextHandler} />
            </SimpleContentComp>
          ))
        )}
        </ImportContentContainer>
        </>
        )}
        <PageAboutTextImport />
      </MainContainer>
  );
};

const MainContainer = styled.div<{ $isActive: boolean }>`
  width: ${({ $isActive }) => $isActive ? '100vw' : '0'};
  height: calc(82vh);
  overflow: hidden;
  transition: all 0.6s ease-in-out;
`

const TitleWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  color: ${({ theme }) => theme.colors.color_Gray_02};
  margin-top: clamp(12px, 2vh, 30px);
  margin-bottom: clamp(20px, 8vh, 30px);
`;

const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  color: ${({ theme }) => theme.colors.color_Gray_01};
`;

const Title = styled.h2`
  ${({ theme }) => theme.typography.Body_01_1};
  color: ${({ theme }) => theme.colors.color_Gray_02};
`;


const ImportContentContainer = styled.div`
  position: relative;
  width: 100%;
  min-height: 65vh;
  max-height: 65vh;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;

  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
`

const NoContentContainer = styled.div`
  width: 100%;
  height: 60vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.colors.color_Gray_04};
  ${({ theme }) => theme.typography.Body_03_2};
`

const SimpleContentComp = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`

export default ImportStationTextMainMobile;
